import { NatGenDesignSystem } from "../../natgen-design-system";
import { progressBarStyles } from "./progress-bar.styles";
import { progressBarTemplate } from "./progress-bar.template";
import { FASTElement } from "@microsoft/fast-element";

/**
 * @element natgen-progress-bar
 */
export class NatGenProgressBar extends FASTElement { }

export const natGenProgressBarDefinition = NatGenProgressBar.compose({
    name: `${NatGenDesignSystem.prefix}-progress-bar`,
    template: progressBarTemplate,
    styles: progressBarStyles
});
